/* eslint-disable no-restricted-globals */
import {useLocation, useNavigate} from "react-router-dom";
import {useEffect} from "react";
import {wrappedFetch} from "component/const/Functions";

export default function Cancel() {
    const location = useLocation();
    const {appId} = location.state;
    const navigate = useNavigate();
    useEffect(() => {
        const cancelConfirm = window.confirm("Are you sure?");
        if (cancelConfirm) {
            wrappedFetch('/activity_test_application?id=eq.'+appId.toString(), {
                method: 'DELETE',
            }, 'https://pgrst.aiteditor.org')
                .then(()=>navigate(-1))
        }else {
            navigate(-1);
        }
    }, []);
}